<template>
    <div
        :class="['answers', `layout-${ layout }`]"
    >
        <template v-for="option in options">
            <div
                :key="option.value"
                class="onboarding-select"
            >
                <input
                    :id="`answer-${ option.value }`"
                    :ref="option.value"
                    type="radio"
                    :value="option.value"
                    :checked="checkedValue === option.value"
                    @change="$event.target.checked && onChange($event.target)"
                >
                <label
                    :for="`answer-${ option.value }`"
                >{{ option.label }}
                </label>
            </div>
        </template>

        <div
            v-if="inputVisible"
            class="extra-field"
        >
            <fieldset>
                <input
                    v-model="tmpValue"
                    type="text"
                    required=""
                    autocomplete="off"
                    @input="updateValue()"
                >
                <label>
                    {{ label }}
                </label>
            </fieldset>
        </div>
    </div>
</template>

<script>
import { find } from 'lodash';

export default {
    props: {
        layout: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        inputKey: {
            type: String,
            default: 'other',
        },
        value: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        checkedValue: null,
        tmpValue: null,
        inputVisible: false,
        lastSelected: null,
    }),

    /**
     * Created hook
     *
     * @returns {void}
     */
    created() {
        if (this.value) {
            this.tmpValue = this.value;

            if (! find(this.options, { value: this.value })) {
                this.checkedValue = this.inputKey;
                this.inputVisible = true;
            } else {
                this.checkedValue = this.value;
            }
        }
    },

    /**
     * Mounted hook
     *
     * @returns {void}
     */
    mounted() {
        const checked = this.$refs[this.checkedValue];

        if (checked) {
            this.lastSelected = checked[0];
        }
    },

    methods: {
        /**
         * Emits 'input' event
         */
        updateValue() {
            this.$emit('input', this.tmpValue);
        },

        /**
         * Toggles extra input visibility
         *
         * @param {HTMLElement} item Radio input value.
         */
        onChange(item) {
            if (this.lastSelected) {
                this.lastSelected.checked = false;
            }

            this.lastSelected = item;

            if ((item.value === this.inputKey)) {
                this.tmpValue = '';
                this.inputVisible = true;
            } else {
                this.tmpValue = item.value;
                this.inputVisible = false;
                this.updateValue();
            }
        },
    },
};
</script>
